import toast, { Renderable, ValueOrFunction } from 'react-hot-toast';

import CustomSvg from '../Svg/CustomSvg';
import i18n from '../../localization/index';

export const AlertSuccess = (msg: string) => {
    return toast.success(msg, { style: { backgroundColor: '#CAFFC4' } });
};
export const AlertError = (msg: string) => {
    return toast.error(msg, { style: { backgroundColor: '#FFCCDB' } });
};
export const AlertWarning = (msg: string) => {
    return toast(msg, {
        icon: <CustomSvg iconName='it-warning-circle' className='icon' style={{ width: '24px', height: '24px' }} />,
        style: { backgroundColor: '#FFE2B7' },
    });
};
export const AlertPromise = (msg: string, promise: Promise<unknown>, success: ValueOrFunction<Renderable, unknown>, error: ValueOrFunction<Renderable, unknown>, withNavigate?: any) => {
    return toast.promise(promise, {
        loading: msg ? msg : 'Loading...',
        success: withNavigate
            ? data => {
                  withNavigate();
                  return i18n.t('generic.success');
              }
            : success,
        error,
    });
};
